import { Box, Typography } from '@mui/material';
import * as React from 'react';

interface QuestionHeaderProps {
  questionNumber: number;
  questionText: string;
  isRequired: boolean;
  isAnswered: boolean;
}

export const QuestionHeader: React.FC<QuestionHeaderProps> = ({
  questionNumber,
  questionText,
  isRequired,
  isAnswered,
}) => {
  console.log('questionNumber: ', questionNumber, 'isAnswered: ', isAnswered);
  const audioUrl = `/audio/${questionNumber}.mp3`;
  // console.log('audioUrl gerado:', audioUrl, 'questionNumber:', questionNumber);
  const questionHtml = questionText.replace(
    '#AUDIO#',
    `<audio src="${audioUrl}" controls style="display:inline-block;vertical-align:middle;margin-left:12px;max-width:280px"></audio>`
  );
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        mb: 3,
        gap: 2,
      }}
    >
      <Box
        sx={{
          flex: 1,
          flexDirection: 'row',
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {/* <Typography
          sx={{
            border: isAnswered ? '3px solid #199215' : '3px solid #667eea',
            textAlign: 'center',
            color: isAnswered ? '#199215' : '#667eea',
            alignContent: 'center',
            alignItems: 'center',
            aspectRatio: '1 / 1',
            justifyContent: 'center',
            borderRadius: '50%',
            height: '40px !important',
            width: '40px !important',
            fontFamily: 'Roboto-Bold !important',
            fontSize: '16pt !important',
          }}
        >
          {questionNumber}
        </Typography> */}
        {/* <Typography
          sx={{
            fontFamily: 'Roboto-Medium !important',
            fontSize: '12pt !important',
            color: '#374151 !important',
            lineHeight: 1.6,
            mb: 1,
          }}
        >
          {questionText}
          {isRequired && (
            <span style={{ color: '#ef4444', marginLeft: '6px' }}>*</span>
          )}
        </Typography> */}

        {/* <Typography
          sx={{
            fontFamily: 'Roboto-Regular !important',
            fontSize: '12pt !important',
            color: '#374151 !important',
            lineHeight: 1.6,
            mb: 1,
          }}
        >
          <span dangerouslySetInnerHTML={{ __html: questionText }} />
          {isRequired && (
            <span style={{ color: '#ef4444', marginLeft: '6px' }}>*</span>
          )}
        </Typography> */}

        <Typography
          component="div" // ← importante! evita <p> dentro de <p>
          sx={{
            fontFamily: 'Roboto-Regular !important',
            fontSize: '12pt !important',
            color: '#374151 !important',
            lineHeight: 1.6,
            mb: 1,
            '& ul': {
              listStyleType: 'disc',
              paddingLeft: '1.5rem',
              marginTop: '0.5rem',
              marginBottom: '0.5rem',
            },
            '& ol': {
              listStyleType: 'decimal',
              paddingLeft: '1.5rem',
            },
            '& li': {
              display: 'list-item',
              marginBottom: '0.25rem',
            },
          }}
        >
          <span
            style={{ textAlign: 'left' }}
            dangerouslySetInnerHTML={{ __html: questionHtml }}
          />
          {isRequired && (
            <span style={{ color: '#ef4444', marginLeft: '6px' }}>*</span>
          )}
        </Typography>
      </Box>
    </Box>
  );
};
